export default {
  'pages.applicationCatalog.openDirectory': 'アプリ管理',
  'pages.applicationCatalog.title': '業務アプリ',
  'pages.applicationCatalog.selectAppHint':
    '左側のアプリを選択すると詳細が表示されます',
  'pages.applicationCatalog.backToCenter': 'アプリに戻る',
  'pages.applicationCatalog.create': 'アプリを新規作成',
  'pages.applicationCatalog.edit': 'アプリを編集',
  'pages.applicationCatalog.refresh': '更新',
  'pages.applicationCatalog.details': '詳細',
  'pages.applicationCatalog.resources': 'リソース管理',
  'pages.applicationCatalog.delete': 'アプリを削除',
  'pages.applicationCatalog.more': 'その他',
  'pages.applicationCatalog.moreForApp': '{name}のその他の操作',
  'pages.applicationCatalog.deleteTitle':
    '「{name}」をプラットフォーム全体から削除しますか？',
  'pages.applicationCatalog.deleteDescription':
    '共有IAMアプリとそのローカル拡張情報が削除され、このアプリを利用するすべての企業に影響します。この操作は元に戻せません。現在の企業だけでアプリの利用を停止する操作ではありません。',
  'pages.applicationCatalog.deleteConfirm': 'プラットフォーム全体から削除',
  'pages.applicationCatalog.cancel': 'キャンセル',
};
